module.exports = __webpack_public_path__ + "img/flag_america.44ec97c1.jpg";